<va-badge [matTooltip]="failureMessage" [color]="color">
  {{ text }}
  @if (isError) {
    <mat-icon>info</mat-icon>
  }
</va-badge>
